export async function deriveHKDF(
  inputKeyMaterial: ArrayBuffer,
  salt: ArrayBuffer,
  info: string,
  length: number = 32
): Promise<ArrayBuffer> {
  const baseKey = await crypto.subtle.importKey(
    'raw',
    inputKeyMaterial,
    'HKDF',
    false,
    ['deriveBits']
  );

  return crypto.subtle.deriveBits(
    {
      name: 'HKDF',
      hash: 'SHA-256',
      salt,
      info: new TextEncoder().encode(info)
    },
    baseKey,
    length * 8
  );
}

export async function deriveHKDFKey(
  inputKeyMaterial: ArrayBuffer,
  salt: ArrayBuffer,
  info: string
): Promise<CryptoKey> {
  const keyMaterial = await deriveHKDF(inputKeyMaterial, salt, info, 32);

  return crypto.subtle.importKey(
    'raw',
    keyMaterial,
    { name: 'AES-GCM' },
    false,
    ['encrypt', 'decrypt']
  );
}